import styled, { css } from "styled-components";

import { APP_GUTTER } from "styles";
import { LG_WIDTH } from "styles/theme/layout";

type PageDividerProps = {
  $isFullWidth?: boolean;
};

export const PageDivider = styled.hr<PageDividerProps>`
  border-color: ${(props) => props.theme.colors.sectionBorder};

  ${(props) =>
    props.$isFullWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    !props.$isFullWidth &&
    css`
      @media (min-width: ${LG_WIDTH}px) {
        margin-left: ${APP_GUTTER}px;
        margin-right: ${APP_GUTTER}px;
      }
    `}
`;
